// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/widget-" + chunkId + "." + {"43":"d902d602","296":"cf830dce","428":"b5665331","433":"697a6a6b","631":"876d4d0b","731":"d8027472","785":"3b96e650"}[chunkId] + ".chunk.js";
};